import { ParsedUrlQuery as UrlQueryToParse } from 'querystring'

type ParsedQueryValue = string | undefined

export const parseQuery = (query: UrlQueryToParse, ...keys: string[]): ParsedQueryValue[] => {
  return keys.map((key) => {
    if (!query?.[key]) {
      return undefined
    }

    const data = query[key]

    return typeof data === 'string' ? data : data?.find((str) => Boolean(str))
  })
}

export const parseQueryParameterAsInteger = (input?: string): number | undefined => {
  if (!input) {
    return undefined
  }

  // Parse the input string as an integer. Note the check `toString() === input` is
  // necessary since parseInt will parse a string with leading digits even if the whole
  // string is not an int. For example, parseInt("123abc") would return `123`.
  const parsed = parseInt(input, 10)
  return !isNaN(parsed) && parsed.toString() === input ? parsed : undefined
}

/**
 * Adds duration milliseconds of artificial delay.
 * @param duration
 * @returns
 */
export const delay = (duration: number) =>
  new Promise((res) =>
    setTimeout(() => {
      res(`Added ${duration}ms of delay.`)
    }, duration)
  )
